/**
 * Generic Form controller for form specific methods/tweaks
 */
export default class FormController {
    constructor() {
        this.init();
    }

    init() {
        // this.initFloatingLabel();

        // if (document.querySelector('.filterableArticles')) {
        //     this.initFiltersForArticleList();
        // }

        // if (document.querySelector('duet-date-picker')) {
        //     this.initDuetDatepicker();
        // }

        if (document.querySelector('.dynamicsInlineForm')) {
            this.initDynamicsInlineForm();
        }

        // this.initQuantityInput();
    }

    initDynamicsInlineForm() {
        const observer = new MutationObserver((mutations, obs) => {
            const forms = document.querySelectorAll('.dynamicsInlineForm form');
            if (forms.length > 0) {
                // Trigger your event or callback here
                document.dispatchEvent(new Event('dynamicsFormLoaded'));
                obs.disconnect(); // Stop observing once the forms are loaded
            }
        });

        observer.observe(document.querySelector('.dynamicsInlineForm'), {
            childList: true,
            subtree: true,
        });

        document.addEventListener('dynamicsFormLoaded', function () {
            const formContainer = document.querySelector('.dynamicsInlineForm');
            const relationType =
                formContainer?.getAttribute('data-relation-type');
            const relationTypeInput = formContainer?.querySelector(
                'input[name="crmp_relatietype"]'
            );

            if (relationType && relationTypeInput) {
                relationTypeInput.value = relationType;
            } else {
                console.error(
                    'No relation type found for Dynamics inline form'
                );
            }
        });
    }

    initFloatingLabel() {
        const shouldFloat = (input) => {
            let float = true;
            if (!input.id) {
                float = false;
            } else if (!document.querySelector(`label[for="${input.id}"]`)) {
                float = false;
            } else if (
                input.type &&
                ['file', 'checkbox', 'radio'].includes(input.type)
            ) {
                float = false;
            }

            return float;
        };

        document
            .querySelectorAll('main form input, main form textarea')
            .forEach((input) => {
                // Check if there's an ID to link a label and there's a label to float
                if (shouldFloat(input)) {
                    const label = document.querySelector(
                        `label[for="${input.id}"]`
                    );
                    const checkFunc = () => {
                        if (input.value.length > 0) {
                            label.classList.add('inputHasValue');
                        } else {
                            label.classList.remove('inputHasValue');
                        }
                    };

                    [
                        'keypress',
                        'keydown',
                        'input',
                        'blur',
                        'focus',
                        'click',
                        'mouseleave',
                        'paste',
                        'cut',
                    ].forEach((event) => {
                        input.addEventListener(event, checkFunc);
                    });

                    input.addEventListener('blur', () =>
                        label.classList.remove('inputHasFocus')
                    );
                    input.addEventListener('focus', () =>
                        label.classList.add('inputHasFocus')
                    );

                    checkFunc();
                    label.classList.add('floating');
                }
            });
    }

    initFiltersForArticleList() {
        document
            .querySelectorAll('.filterableArticles')
            .forEach((container) => {
                if (container.querySelector('.filtersColumn .filter')) {
                    container
                        .querySelector('.filtersColumn .filter .openFilter')
                        .addEventListener('click', (e) => {
                            document
                                .querySelector('.filtersColumn .filter')
                                .classList.toggle('popupActive');
                        });

                    container
                        .querySelector('.filtersColumn .filter .closePopup')
                        .addEventListener('click', (e) => {
                            document
                                .querySelector('.filtersColumn .filter')
                                .classList.remove('popupActive');
                        });
                }
            });
    }

    initDuetDatepicker() {
        import(
            /* webpackChunkName: "modules/datepicker" */ '@duetds/date-picker/custom-element'
        ).then((e) => {
            customElements.whenDefined('duet-date-picker').then(() => {
                document
                    .querySelectorAll('duet-date-picker')
                    .forEach((picker) => {
                        picker.localization = {
                            buttonLabel: 'Kies een datum',
                            calendarHeading: 'Kies een datum',
                            closeLabel: 'Sluit scherm',
                            dayNames: [
                                'Zondag',
                                'Maandag',
                                'Dinsdag',
                                'Woensdag',
                                'Donderdag',
                                'Vrijdag',
                                'Zaterdag',
                            ],
                            keyboardInstruction:
                                'Gebruik de pijltjestoetsen om door de datums te bladeren',
                            locale: 'nl-NL',
                            monthNames: [
                                'januari',
                                'februari',
                                'maart',
                                'april',
                                'mei',
                                'juni',
                                'juli',
                                'augustus',
                                'september',
                                'oktober',
                                'november',
                                'december',
                            ],
                            monthNamesShort: [
                                'jan',
                                'feb',
                                'mrt',
                                'apr',
                                'mei',
                                'jun',
                                'jul',
                                'aug',
                                'sep',
                                'oct',
                                'nov',
                                'dec',
                            ],
                            monthSelectLabel: 'Maand',
                            nextMonthLabel: 'Volgende maand',
                            placeholder: 'JJJJ-MM-DD',
                            prevMonthLabel: 'Vorige maand',
                            selectedDateMessage: 'Geselecteerde maand:',
                            yearSelectLabel: 'Jaar',
                        };
                    });
            });

            window.customElements.define('duet-date-picker', e.DuetDatePicker);
        });
    }

    initQuantityInput() {
        document.querySelectorAll('.quantityInput').forEach((quantityInput) => {
            const minButton = quantityInput.querySelector('button.min');
            const plusButton = quantityInput.querySelector('button.plus');
            const input = quantityInput.querySelector('input');
            let currentValue = input.value;

            const triggerEvent = () => {
                let event = new CustomEvent('update', {
                    detail: parseInt(input.value),
                });

                quantityInput.dispatchEvent(event);
                input.dispatchEvent(event);
            };

            input.addEventListener('click', (e) => {
                input.setSelectionRange(0, input.value.length);
            });

            this.createInputFilter(input, (val) => {
                return /[0-9]/.test(val);
            });

            input.addEventListener('blur', (e) => {
                if (input.value !== currentValue && /[0-9]/.test(input.value)) {
                    currentValue = input.value;
                    triggerEvent();
                } else {
                    input.value = currentValue;
                }
            });

            minButton.addEventListener('click', (e) => {
                e.preventDefault();
                if (Number.isInteger(parseInt(input.value))) {
                    if (e.ctrlKey) {
                        input.value = parseInt(input.value) - 100;
                    } else if (e.shiftKey) {
                        input.value = parseInt(input.value) - 10;
                    } else {
                        input.value = parseInt(input.value) - 1;
                    }

                    if (input.min && parseInt(input.value) < input.min) {
                        input.value = input.min;
                    }

                    if (currentValue != input.value) {
                        triggerEvent();
                        currentValue = input.value;
                    }
                }
            });

            plusButton.addEventListener('click', (e) => {
                e.preventDefault();
                if (Number.isInteger(parseInt(input.value))) {
                    if (e.ctrlKey) {
                        input.value = parseInt(input.value) + 100;
                    } else if (e.shiftKey) {
                        input.value = parseInt(input.value) + 10;
                    } else {
                        input.value = parseInt(input.value) + 1;
                    }

                    if (input.max && parseInt(input.value) > input.max) {
                        input.value = input.max;
                    }

                    if (currentValue != input.value) {
                        triggerEvent();
                        currentValue = input.value;
                    }
                }
            });
        });
    }

    createInputFilter(input, filter) {
        let oldValue = input.value;
        let oldSelectionStart;
        let oldSelectionEnd;

        [
            'input',
            'keydown',
            'keyup',
            'mousedown',
            'mouseup',
            'select',
            'contextmenu',
            'drop',
        ].forEach((ev) => {
            input.addEventListener(ev, () => {
                if (filter(input.value)) {
                    oldValue = input.value;
                    oldSelectionStart = input.selectionStart;
                    oldSelectionEnd = input.selectionEnd;
                } else {
                    input.value = oldValue;
                    input.setSelectionRange(oldSelectionStart, oldSelectionEnd);
                }
            });
        });
    }

    newPage() {
        this.init();
    }
}
